<template>
    <md-dialog :md-active.sync="active" :md-close-on-esc="false"
    :md-click-outside-to-close="false">
    <md-dialog-title>{{ i18n.lbl_sub() }} - {{sub.Description}}</md-dialog-title>
    <detail :prop="i18n.lbl_exchange_asset()"  :value="sub.Asset"/>
    <detail :prop="i18n.lbl_balance()"  :value="sub.Balance"/>
    <detail :prop="i18n.lbl_my_wallet()"  :value="sub.WalletId"/>
    <div class="transfer-inputs">
      <div class="input-wrap">
        <input-field :label="i18n.lbl_amount()" v-model.trim="amount" @blur="checkAmount()"/>
      </div>
      <div class="input-wrap" v-if="subWalletsByCurrency.length">
        <select-field2 :values="subWalletsByCurrency" :label="i18n.lbl_my_wallet()" v-model="receiver"/>
      </div>
    </div>
    <md-dialog-actions>
        <md-button class="md-button btn md-primary md-theme-default" @click="close" :disabled="isLoading">{{ i18n.lbl_cancel() }}</md-button>
        <md-button class="md-button btn md-primary md-theme-default" @click="transfetToWallet" :disabled="isSend">{{ i18n.lbl_send() }}</md-button>
    </md-dialog-actions>
    </md-dialog>
</template>
    
<script>
import { i18n } from '@js/i18n'
import Detail from '@vue/app/common/Detail.Row'
import SelectField2 from '@com/fields/SelectField2'
import InputField from '@com/fields/InputField'
import CurrencyRound from '@com/mixins/currency.round.mixin'

export default {
  name: 'TransferSubModal',
  components: { Detail, SelectField2, InputField },
  mixins: [CurrencyRound],
  data () {
    return {
      i18n,
      isLoading: false,
      amount: '0',
      receiver: ''
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    sub: {
      type: Object,
      required: true
    },
    wallets: {
      type: Array,
      required: true
    }
  },
  emits: ['close', 'deleteSubWallet', 'transfer'],
  computed: {
    subWalletsByCurrency () {
      let subs = this.wallets.filter(el => el.Asset === this.sub.Asset) || []
      if (subs.length) {
        return subs.filter(el => el.WalletId !== this.sub.WalletId)
      }
      return []
    },
    isSend () {
      return this.isLoading || Number(this.amount) <= 0 || Number(this.amount) > Number(this.sub.Balance) || !this.receiver
    }
  },
  methods: {
    close () {
      this.$emit('close', null)
    },
    async transfetToWallet () {
      await this.$emit('transfer', {
        user_id: this.sub.UserId,
        sender_wallet_id: this.sub.WalletId,
        receiver_wallet_id: this.receiver,
        amount: Number(this.amount) * 1000000,
        asset: this.sub.Asset
      })
    },
    checkAmount () {
      this.amount = this.roundCurrency(this.amount, this.sub.Asset)
    }
  }
}
</script>

<style scoped lang="scss">
.md-title {
    padding-left: 0;
}
.transfer-inputs {
    display: flex;
    gap: 10px;
    .input-wrap {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/vue/app/dashboard/index/TransferSubModal.vue